import { useTranslation } from "react-i18next";
import type { Allergen } from "../../../../api/menu";
import { getTranslation } from "../../../../utils/translations";

/**
 * Легендата на алергените най-отдолу на хартията: номерът (= id-то на
 * алергена, по закона — org миграция e7fd010860e9) и името му. Само номерата,
 * които се срещат в отпечатаното меню, по ред.
 */
export const LunchAllergenLegend = ({ allergens }: { allergens: Allergen[] }) => {
  const { t, i18n } = useTranslation();
  if (allergens.length === 0) return null;
  return (
    <div className="mt-6 flex flex-col gap-1.5 border-t border-shade-2 pt-4">
      <span className="font-pos-mono text-[9pt] font-semibold uppercase tracking-[.1em] text-muted">
        {t("lunchMenu.printAllergensTitle")}
      </span>
      <div className="grid grid-cols-2 gap-x-6 gap-y-0.5 text-[9pt] text-soft">
        {allergens.map((allergen) => (
          <span key={allergen.id}>
            <span className="font-pos-mono font-bold text-ink">{allergen.id}</span>
            {" — "}
            {getTranslation(allergen.translations, i18n.language, allergen.slug)}
          </span>
        ))}
      </div>
    </div>
  );
};
